[
  {
    "code": "NE-1",
    "name": "Agadez"
  },
  {
    "code": "NE-2",
    "name": "Diffa"
  },
  {
    "code": "NE-3",
    "name": "Dosso"
  },
  {
    "code": "NE-4",
    "name": "Maradi"
  },
  {
    "code": "NE-8",
    "name": "Niamey"
  },
  {
    "code": "NE-5",
    "name": "Tahoua"
  },
  {
    "code": "NE-6",
    "name": "Tillabéri"
  },
  {
    "code": "NE-7",
    "name": "Zinder"
  }
]